var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-date-picker',_vm._b({attrs:{"mode":"year","format":"YYYY","open":_vm.open,"value":_vm.value,"getCalendarContainer":(trigger) => trigger.parentNode},on:{"openChange":_vm.handleOpenChange,"panelChange":_vm.handlePanelChange,"change":_vm.handleChange}},'a-date-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }